import LoadbarComponent from "slotworks/components/preloader/loadbar-component";
import { FileLocation } from "slotworks/config/asset-config-schema";
import Layers from "slotworks/graphics/layers/layers";
import Translations from "slotworks/i18n/translations";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";

class PreloaderComponent {

    public static SCENES: {[key: string]: string} = {
        "default": "preloader",
        "568": "preloader568"
    }

    private loadBar: LoadbarComponent;

    private progressText: PIXI.Text;

    public init(files: FileLocation[]) {
        const sceneId = revolverModel.getLoader() || "default";
        
        Layers.Background.setScene("preloader").execute();
        if(PreloaderComponent.SCENES[sceneId] && Layers.Menus.hasScene(PreloaderComponent.SCENES[sceneId])) {
            Layers.Background.setScene(PreloaderComponent.SCENES[sceneId]).execute();
            Layers.Menus.setScene(PreloaderComponent.SCENES[sceneId]).execute();
        } else {            
            Layers.Menus.setScene("preloader").execute();
        }

        // Graphics
        let bar: PIXI.DisplayObject = Layers.Menus.getSprite("loader_bar");
        const chaser = Layers.Menus.getSprite("loader_bar_chaser");
        this.progressText = Layers.Menus.getText("loader_text");

        const barMask = Layers.Menus.getSprite("loader_bar_mask");
        if (barMask) {
            const mask = new PIXI.Graphics();
            mask.x = barMask.x;
            mask.y = barMask.y;
            mask.beginFill(0xff0000);
            mask.drawRect(0, 0, barMask.width, barMask.height);
            barMask.visible = false;
            bar.mask = mask;

            bar = mask;

            Layers.Menus.add(mask);
        }

        this.loadBar = new LoadbarComponent(bar, files, chaser);

        this.loadBar.onChange.add(() => this.update());
    }

    public fileLoaded(resource: PIXI.loaders.Resource) {

        this.loadBar.fileLoaded(resource);
    }

    /**
     * Quickly completes the loadbar and returns a Contract for when it's done
     */
    public loadComplete() {
        SoundManager.event(SoundEvent.preload_complete);

        return this.loadBar.loadComplete();
    }

    public destroy() {
        this.progressText = null;

        Layers.Background.defaultScene().execute();
        Layers.Menus.clear();
    }

    private update() {
        if (this.progressText) {
            this.progressText.text = Translations.get("prl.loa", { PROGRESS: Math.round(this.loadBar.currentPercent * 100) });
        }
    }
}

export default PreloaderComponent;



// WEBPACK FOOTER //
// ./~/slotworks/components/preloader/preloader-component.ts